export const ApplicationType = 1;
export const Platform = 1;
export const sessiontime = 20000000;
export const minimumbalance = 10;
 
let geoCache = null;
let geoPromise = null;
 
export const getGeolocation = async () => {
  const savedGeo = sessionStorage.getItem("geoLocation");
 
  if (savedGeo) {
    geoCache = savedGeo;
    return geoCache;
  }
 
  if (geoCache) return geoCache;
  if (geoPromise) return geoPromise;
 
  geoPromise = new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve(null);
      return;
    }
 
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude.toFixed(4);
        const lon = position.coords.longitude.toFixed(4);
 
        geoCache = `${lat},${lon}`;
        sessionStorage.setItem("geoLocation", geoCache);
 
        geoPromise = null; 
        resolve(geoCache);
      },
      (error) => {
        console.log("Geo Error:", error);
        geoPromise = null; 
        resolve(null);
      },
    );
  });
 
  return geoPromise;
};

export const orderID = (() => {
  const now = new Date();
  const year = now.getFullYear().toString(); // 4 digits
  const month = String(now.getMonth() + 1).padStart(2, "0"); // 2 digits
  const hour = String(now.getHours()).padStart(2, "0"); // 2 digits
  const minute = String(now.getMinutes()).padStart(2, "0"); // 2 digits
  const timePart = String(now.getTime()).slice(-8); // 8 digits
 
  // 6-digit random number (to reach exact 24 total)
  const randomPart = String(Math.floor(100000 + Math.random() * 900000));
 
  // Final length: 4 + 2 + 2 + 8 + 6 + 2 = 24
  return `${timePart}${randomPart}${minute}`;
})();
 
export const generateOrderId = ({ mobileNumber = "", accountNo = "" }) => {
  const now = new Date();
  const year = now.getFullYear().toString(); // 4 digits
  const month = String(now.getMonth() + 1).padStart(2, "0"); // 2 digits
  const hour = String(now.getHours()).padStart(2, "0"); // 2 digits
  const minute = String(now.getMinutes()).padStart(2, "0"); // 2 digits
  const timePart = String(now.getTime()).slice(-8); // 8 digits
 
  // 6-digit random number (to reach exact 24 total)
  const randomPart = String(Math.floor(100000 + Math.random() * 900000));
  return `${timePart}${randomPart}${minute}`;
};
 
//staging
//  export const entity_id = 65;
// export const payuPayment = "https://test.payu.in/_payment";
// export const returnurl =
//   "https://staging.transactionanalysts.com:444/TAMultiTenantAPI/PayUPG_Web_ResponseHandler.aspx";
 

//production
export const entity_id = 77;
export const payuPayment = "https://secure.payu.in/_payment";
export const returnurl =
  "https://taapp.transactionanalysts.com:444/Oneapp/PayUPG_Web_ResponseHandler.aspx";


  export const tapay_callbackurl = "https://taapp.transactionanalysts.com:444/Oneapp/PG_Web_ResponseHandler.aspx"

  export const apspdcl_callbackurl="https://taapp.transactionanalysts.com:444/TAMultiTenantAPI/APSPDCL_TaPayWeb_ResponseHandler.aspx"



  // export const returnurl =
//   "https://taapp.transactionanalysts.com:8089/apiwallet/api/v1/services/paymentgateway/callbackurl";

 

// export const returnurl =

//   "http://localhost:8089/apiwallet/api/v1/services/paymentgateway/callbackurl";


export const faq =
  "http://taapp.transactionanalysts.com:444/helpnfaq/TAWallet_HelpFAQ.aspx?Wallet_Type_blank";
 
export const date = (() => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
})();
 
export const location = sessionStorage.getItem("geoLocation") || "17.111,17.99";
export const address1 = sessionStorage.getItem("address1");
export const address2 = sessionStorage.getItem("address2");
export const city = sessionStorage.getItem("address2")?.replace(/"/g, "");
export const state = sessionStorage.getItem("state")?.replace(/"/g, "");
export const zipcode = sessionStorage.getItem("zipcode");
export const locationGeo = sessionStorage.getItem("geoLocation") || "17.111,17.99";
export const country = "INDIA";


export const apspdclServiceId = 26;